import React from 'react'
import { Box, IconButton, Menu, MenuButton, MenuDivider, MenuItem, MenuList } from '@chakra-ui/react'
import { IoChevronDownOutline } from "react-icons/io5";
import { redirectToNewPage } from '../../global/helpers/global-helpers';
import useProspectorTour from '../../global/hooks/prospector-product-tour';


export default function ProspectorHeaderOptionsButton({ 
    setIsReadingMode,
    isReadingMode,
    isProspectorOwner,
    pDsrId,
    dsrTitle,
    handleChangeUserActionRequired,
    setShowShareElements,
    setShowQueryDrawer
  }) {
    
    const { startProspectorTour } = useProspectorTour({
      setShowShareElements,
      setShowQueryDrawer
    });

    const handleUnpublishProspector = () => {
      handleChangeUserActionRequired('unpublish-prospect-dsr-card', {
        pDsrId,
        dsrTitle
      })
    }
  
  function renderAdminOptions() {
      return (
        <MenuList px='0.5em' fontSize='0.875em'>
        {pDsrId && <MenuItem name='copy-link-option' className='filter-menu__dropdown-option-display' onClick={() => redirectToNewPage(`/edit/pdsr/${pDsrId}`)}  >Edit Prospector</MenuItem>}
        <MenuItem name='copy-link-option' className='filter-menu__dropdown-option-display' onClick={() => handleUnpublishProspector()}  >Unpublish Prospector</MenuItem>
        <MenuDivider />
        <MenuItem name='copy-link-option' className='filter-menu__dropdown-option-display' onClick={() => setIsReadingMode(typeof isReadingMode === "boolean" ? !isReadingMode : true )}  >Reading Mode <span><Box fontSize='0.7em' fontWeight='600' color={isReadingMode ? 'brand.500' : 'gray.500'} ml='0.5em'>{isReadingMode ? "ON" : "OFF"}</Box></span></MenuItem>
        {renderProspectorTourOption()}
      </MenuList>
      )
  }

   function renderProspectorTourOption() {
      return (
        <MenuItem name='copy-link-option' className='filter-menu__dropdown-option-display' onClick={() => startProspectorTour()}>
          Prospector tour
        </MenuItem>
      )
    }

  function renderNonAdminOptions() {
    return (
      <MenuList px='0.5em' fontSize='0.875em'>  
        <MenuItem name='copy-link-option' className='filter-menu__dropdown-option-display' onClick={() => setIsReadingMode(typeof isReadingMode === "boolean" ? !isReadingMode : true )}  >Reading Mode <span><Box fontSize='0.7em' fontWeight='600' color={isReadingMode ? 'brand.500' : 'gray.500'} ml='0.5em'>{isReadingMode ? "ON" : "OFF"}</Box></span></MenuItem>
      </MenuList>
    )
  }

  return (
    <React.Fragment>

      <Menu isLazy placement="bottom-end" bg='gray.500'>
        <MenuButton
          as={IconButton}
          aria-label='Options'
          icon={<IoChevronDownOutline />}
          size='2em'
          p='0.5em'
          rounded='50%'
        />
       {isProspectorOwner ? renderAdminOptions(): renderNonAdminOptions()}
      </Menu>

    </React.Fragment>
  );

}